import * as React from 'react';
import {useEffect, useState} from 'react';
import {showToastForBackend, showToastForFrontend} from "../../actions/toastActions";
import {
    Button,
    CircularProgress,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField
} from "@mui/material";
import Box from "@mui/material/Box";
import axios from "axios";
import axiosConfig from "../../utils/axiosConfig";
import messageCodes from "../../utils/messageCodes";
import {DataGrid, GridToolbarColumnsButton, GridToolbarContainer} from "@mui/x-data-grid";
import DataDetailModal from "./DataDetailModal";
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import FilterListIcon from '@mui/icons-material/FilterList';
import {connect} from "react-redux";


export const EventDataDetail = (props) => {

    const [userId, setUserId] = useState(localStorage.getItem('eventFilterSettings') ?
        JSON.parse(localStorage.getItem('eventFilterSettings')).userId : "");

    const [selectedEventTypeFirstOption, setSelectedEventTypeFirstOption] = useState(localStorage.getItem('eventFilterSettings') ?
        JSON.parse(localStorage.getItem('eventFilterSettings')).selectedEventTypeFirstOption : "");

    const [selectedEventTypeSecondOption, setSelectedEventTypeSecondOption] = useState(localStorage.getItem('eventFilterSettings') ?
        JSON.parse(localStorage.getItem('eventFilterSettings')).selectedEventTypeSecondOption : "");

    const [selectedOption, setSelectedOption] = useState(localStorage.getItem('eventFilterSettings') ?
        JSON.parse(localStorage.getItem('eventFilterSettings')).selectedOption : "byUser");

    const [fromTime, setFromTime] = useState(dayjs(localStorage.getItem('eventFilterSettings') ?
        JSON.parse(localStorage.getItem('eventFilterSettings')).fromTime : new Date()));

    const [toTime, setToTime] = useState(dayjs(localStorage.getItem('eventFilterSettings') ?
        JSON.parse(localStorage.getItem('eventFilterSettings')).toTime : new Date()));

    const [showTable, setShowTable] = React.useState(false);
    const [eventList, setEventList] = useState([]);
    const [columns, setColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [eventTypes, setEventTypes] = useState([]);
    const [userIdErrorText, setUserIdErrorText] = useState([]);
    const [showFilter, setShowFilter] = useState(true);

    useEffect(() => {
        fetchEventTypes();
    }, []);

    useEffect(() => {
        let eventFilterSettings = localStorage.getItem('eventFilterSettings') ?
            JSON.parse(localStorage.getItem('eventFilterSettings')) : null;
        if (eventFilterSettings !== null) {
            let toTime = dayjs(eventFilterSettings.toTime);
            let fromTime = dayjs(eventFilterSettings.fromTime);
            fetchEvents(eventFilterSettings.userId, eventFilterSettings.eventType, fromTime.toDate().getTime(), toTime.toDate().getTime());
        }
    }, []);

    const fetchEvents = async (userId, eventType, fromTime, toTime) => {
        setIsLoading(true);
        let requestBody = {
            limit: 100,
            userId: userId,
            fromTime: fromTime,
            toTime: toTime,
            eventType: eventType
        }
        await axios.post(props.properties.databaseUrl + "/events", requestBody, axiosConfig())
            .then((response) => {
                    if (response.data.length > 0) {
                        let array = [];
                        response.data.forEach(key => {
                            key.map.eventType = key.eventType;
                            key.map.id = key.id;
                            key.map.time = key.time;
                            array.push(key.map)
                        })
                        setEventList(array);
                        let columnHeaders = findUniqueFields(response.data);
                        columnHeaders = columnHeaders.filter(c => !["id", "map"].includes(c));
                        initVisibleColumns(columnHeaders);
                    } else {
                        setEventList(response.data);
                    }
                    setShowTable(true);
                }
            )
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                    setEventList([]);
                    setShowTable(true);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    };

    const fetchEventTypes = async () => {
        setIsLoading(true);
        await axios.get(props.properties.databaseUrl + "/distinctEventTypes", axiosConfig())
            .then((response) => {
                setEventTypes(response.data);
                if (selectedEventTypeFirstOption === "") {
                    setSelectedEventTypeFirstOption(response.data[0]);
                }
                if (selectedEventTypeSecondOption === "") {
                    setSelectedEventTypeSecondOption(response.data[0]);
                }
            })
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    };

    const initVisibleColumns = (columnHeaders) => {
        let initColumnHeaders = [];
        initColumnHeaders.push({
            field: 'eventType',
            headerName: 'Event Type',
            width: 200,
            sortable: false,
        });
        if (columnHeaders.includes("userId")) {
           initColumnHeaders.push({
                field: 'userId',
                headerName: 'User Id',
                width: 200,
                sortable: false,
            });
        }
        initColumnHeaders.push({
            field: 'time',
            headerName: 'Time',
            width: 250,
            sortable: false,
            renderCell: (params) => {
                const date = new Date(params.value).toLocaleString();
                return <span>{date}</span>;
            }
        });
        let notVisible = [];
        columnHeaders.filter(c => !["userId", "time", "eventType"].includes(c)).forEach((key) => {
                let column = {
                    field: key,
                    headerName: key,
                    sortable: false,
                    width: 200,
                }
                notVisible[key] = false;
                initColumnHeaders.push(column)
            }
        );
        let infoButton = {
                field: 'action',
                headerName: '',
                width: 180,
                sortable: false,
                disableClickEventBubbling: true,
                renderCell: (params) =>
                    <DataDetailModal selectedRow={params.row}/>
            }
        initColumnHeaders.push(infoButton);
        setColumns(initColumnHeaders);
        let visible = localStorage.getItem('eventVisibleColumn') ?
            JSON.parse(localStorage.getItem('eventVisibleColumn')) : notVisible;
        setVisibleColumns(visible);
    }
    const onUserIdChange = (e) => setUserId(e.target.value);
    const onEventTypeFirstOptionChange = (e) => setSelectedEventTypeFirstOption(e.target.value);
    const onEventTypeSecondOptionChange = (e) => setSelectedEventTypeSecondOption(e.target.value);
    const closeFilter = () => setShowFilter(false);
    const openFilter = () => setShowFilter(true);
    const onSelectedOptionChange = (e) => setSelectedOption(e.target.value);
    const onVisibilityModelChange = (newModel) => {
        setVisibleColumns(newModel);
        localStorage.setItem('eventVisibleColumn', JSON.stringify(newModel));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let eventType = selectedOption === "byUser" ? selectedEventTypeFirstOption : selectedEventTypeSecondOption;
        let user = selectedOption === "byUser" ? userId : "";
        if (selectedOption === "byUser" && user === "") {
            setUserIdErrorText("This field can not be empty!");
        } else {
            setUserIdErrorText("");
            fetchEvents(user, eventType, fromTime.toDate().getTime(), toTime.toDate().getTime());
            setShowFilter(false);
            let eventFilterSettings = {
                selectedOption: selectedOption,
                userId: user,
                toTime: toTime,
                fromTime: fromTime,
                eventType: eventType,
                selectedEventTypeFirstOption: selectedEventTypeFirstOption,
                selectedEventTypeSecondOption: selectedEventTypeSecondOption
            }
            localStorage.setItem('eventFilterSettings', JSON.stringify(eventFilterSettings));
        }
    }
    const tableSize = showFilter ? {height: '50%', width: '100%'} : {height: '100%', width: '100%'};
    return (
        <div className='data-content'>
            <div className="data-space">
            {isLoading && (
                <CircularProgress/>)}</div>
            {showFilter && (
                <div className="form">
                <Box component="form" onSubmit={handleSubmit} sx={{display: 'flex', flexDirection: 'column',
                    alignItems: 'center'}} noValidate>
                    <div className='filter-form'>
                        <RadioGroup
                            className="radio-group"
                            defaultValue="byUser"
                            name="radio-buttons-group"
                            onChange={onSelectedOptionChange} value={selectedOption}>
                            <FormControlLabel value="byUser"
                                              control={<Radio/>}
                                              label="Filter by user id and event type"/>
                            <FormControlLabel value="byDate"
                                              control={<Radio/>}
                                              label="Filter by event type and date range"/>
                        </RadioGroup>
                        {selectedOption === 'byUser' && (
                            <div className="filter-options">
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="user"
                                    label="User Id"
                                    helperText={userIdErrorText}
                                    onChange={onUserIdChange}
                                    value={userId}
                                    autoComplete="user"
                                    autoFocus
                                    sx={{
                                        '.MuiFormHelperText-root': {
                                            color: '#ff0000'
                                        }
                                    }}
                                />
                                <InputLabel id="eventTypeFirstOption">Event Type</InputLabel>
                                <Select
                                    id="eventTypeFirstOption"
                                    label="Event Type"
                                    onChange={onEventTypeFirstOptionChange}
                                    value={selectedEventTypeFirstOption}>
                                    {eventTypes.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            <Typography>{type}</Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        )}
                        {selectedOption === 'byDate' && (
                            <div className="filter-options">
                                <InputLabel id="eventTypeSecondOption">Event Type</InputLabel>
                                <Select
                                    id="eventTypeSecondOption"
                                    label="Event Type"
                                    onChange={onEventTypeSecondOptionChange}
                                    value={selectedEventTypeSecondOption}>
                                    {eventTypes.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="date-picker">
                                        <DatePicker
                                            label="From"
                                            value={fromTime}
                                            onChange={(newValue) => setFromTime(newValue)}/>
                                    </div>
                                    <div className="date-picker">
                                        <DatePicker
                                            label="To"
                                            value={toTime}
                                            onChange={(newValue) => setToTime(newValue)}
                                        />
                                    </div>
                                </LocalizationProvider>
                            </div>
                        )}
                    </div>
                    <div className="filter-button">
                        <Button
                            type="submit"
                            variant="outlined"
                            sx={{width: '100%', m: 2}}>
                            Search
                        </Button>
                        {showTable && (
                            <Button variant="outlined" sx={{width: '100%', m: 2}} onClick={closeFilter}>Close</Button>
                        )}
                    </div>
                </Box>
                </div>)}

            {showTable && (
                <div style={tableSize}>
                    <DataGrid
                        sx={{
                            '.MuiDataGrid-columnHeaderTitle': {
                                color: '#86BC25FF',
                            },
                            '.MuiTablePagination-root': {
                                color: '#a6a8ab'
                            }
                        }}
                        disableSelectionOnClick
                        className= "data-table"
                        rows={eventList}
                        getRowId={(row) => row.id}
                        columns={columns}
                        loading={isLoading}
                        columnVisibilityModel={visibleColumns}
                        onColumnVisibilityModelChange={onVisibilityModelChange}
                        slots={{
                            toolbar: CustomToolbar
                        }}
                        slotProps={{
                            toolbar: {
                                openFilter: openFilter
                            },
                        }}
                        initialState={{
                            pagination: {paginationModel: {pageSize: 25}},
                        }}
                        pageSizeOptions={[5, 10, 25]}
                    />
                </div>
            )}
        </div>
    );
}

function findUniqueFields(obj) {
    const uniqueFields = new Set();
    function traverse(obj) {
        if (typeof obj !== 'object' || obj === null) {
            return;
        }
        if (Array.isArray(obj)) {
            obj.forEach(traverse);
        } else {
            Object.keys(obj).forEach(key => {
                uniqueFields.add(key);
                traverse(obj[key]);
            });
        }
    }
    traverse(obj);
    return Array.from(uniqueFields);
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
    }
}

export function CustomToolbar(props) {
    return (
        <GridToolbarContainer className="data-toolbar">
            <GridToolbarColumnsButton/>
            <Button type="link"
                    onClick={props.openFilter} sx={{
                fontSize: '0.8125rem', padding: '4px 5px'
            }} startIcon={<FilterListIcon/>}>
                Filters
            </Button>
        </GridToolbarContainer>
    );
}
export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(EventDataDetail);